import { type ImageLoaderProps } from 'next/image';

const replaceAbsolutePathWithRelative = (url: string): string => {
  const absolutePathPattern = /^https?:\/\/[^/]+/u;
  return url.replace(absolutePathPattern, '');
};

const getRootUrl = (url: string): null | string => {
  try {
    const { hostname, protocol } = new URL(url);
    return `${protocol}//${hostname}`;
  } catch {
    return null;
  }
};

export const imageLoader = ({ src, width }: ImageLoaderProps) => {
  const rootUrl = getRootUrl(src);
  const relativePath = replaceAbsolutePathWithRelative(src);

  const optimizelySiteUrl =
    typeof window !== 'undefined'
      ? window.PUBLIC_ENV.optimizelySiteUrl
      : process.env.OPTIMIZELY_SITE_URL;
  const optimizelySiteSecondaryUrl =
    typeof window !== 'undefined'
      ? window.PUBLIC_ENV.optimizelySiteSecondaryUrl
      : process.env.OPTIMIZELY_SITE_SECONDARY_URL;
  const assetsSiteUrl = 'https://assets.mdrt.org';

  switch (rootUrl) {
    case assetsSiteUrl:
      return `${src}?width=${width}`;
    case optimizelySiteSecondaryUrl:
    case optimizelySiteUrl:
      return `${rootUrl}/cdn-cgi/image/width=${width},format=auto${relativePath}`;
    default:
      return src;
  }
};
